// TODO: DSP-4138 - Migrate to @atlaskit/design-system
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React from 'react';
export default function IconDatasourceJiraIssue() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_53432)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "40",
    height: "40",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 12H44V22H18V12Z",
    fill: "white",
    stroke: "#C1C7D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8H43C43.5523 8 44 8.44772 44 9V12H18V8Z",
    fill: "#DFE1E6",
    stroke: "#C1C7D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 22H44V31C44 31.5523 43.5523 32 43 32H18V22Z",
    fill: "white",
    stroke: "#C1C7D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12H19V22H7V12Z",
    fill: "white",
    stroke: "#C1C7D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9C7 8.44772 7.44772 8 8 8H19V12H7V9Z",
    fill: "#DFE1E6",
    stroke: "#C1C7D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 22H19V32H8C7.44772 32 7 31.5523 7 31V22Z",
    fill: "white",
    stroke: "#C1C7D0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "10",
    y: "14",
    width: "6",
    height: "6",
    rx: "1",
    fill: "#FF5230"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 18C13.5523 18 14 17.5523 14 17C14 16.4477 13.5523 16 13 16C12.4477 16 12 16.4477 12 17C12 17.5523 12.4477 18 13 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "10",
    y: "24",
    width: "6",
    height: "6",
    rx: "1",
    fill: "#36B37E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2 25.7002C12.0895 25.7002 12 25.7897 12 25.9002V28.2174C12 28.3955 12.2154 28.4848 12.3414 28.3588L13 27.7002L13.6586 28.3588C13.7846 28.4848 14 28.3955 14 28.2174V25.9002C14 25.7897 13.9105 25.7002 13.8 25.7002H12.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "22",
    y: "16",
    width: "19",
    height: "2",
    rx: "1",
    fill: "#C1C7D0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "22",
    y: "26",
    width: "19",
    height: "2",
    rx: "1",
    fill: "#C1C7D0"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_53432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "40",
    height: "40",
    rx: "3",
    fill: "white"
  }))));
}